import React from "react";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import RequireAuth from "./AuthRouter";
import Container from "./Container";
import LoginPage from "../pages/LoginPage";
import ForgotPasswordPage from "../pages/ForgotPasswordPage";
import ResetPasswordPage from "../pages/ResetPasswordPage";
import RegisterPage from "../pages/RegisterPage";
import DashboardPage from "../pages/DashboardPage";
import CompanyPage from "../pages/CompanyPage";
import CompaniesPage from "../pages/CompaniesPage";
import CompanyDetailsPage from "../pages/CompanyDetailsPage";
import ProductsPage from "../pages/ProductsPage";
import CategoriesPage from "../pages/CategoriesPage";
import SubcategoriesPage from "../pages/SubcategoriesPage";
import NewProductPage from "../pages/NewProductPage";
import SegmentationPage from "../pages/SegmentationPage";
import AssinaturaPage from "../pages/AssinaturaPage";
import NotFoundPage from "../pages/NotFoundPage";
import AdminProductsPage from "../pages/AdminProductsPage";
import AdminAssinaturasPage from "../pages/AdminAssinaturasPage";
import AdminCustomersPage from "../pages/AdminCustomersPage";
import ChatPage from "../pages/ChatPage";
import ServicosPage from "../pages/ServicosPage";
import FaturasPage from "../pages/FaturasPage";
import PagamentoRetornoPage from "../pages/PagamentoRetornoPage";

const AppRouter = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/esqueci-senha" element={<ForgotPasswordPage />} />
        <Route path="/redefinir-senha" element={<ResetPasswordPage />} />
        <Route path="/cadastro" element={<RegisterPage />} />
        <Route
          path="/"
          element={
            <RequireAuth>
              <Container>
                <Outlet />
              </Container>
            </RequireAuth>
          }
        >
          <Route index element={<DashboardPage />} />
          <Route path="dashboard" element={<DashboardPage />} />
          <Route path="empresa" element={<CompanyPage />} />
          <Route path="empresas" element={<CompaniesPage />} />
          <Route path="empresas/:companyId" element={<CompanyDetailsPage />} />
          <Route path="produtos" element={<ProductsPage />} />
          <Route path="admin/produtos" element={<AdminProductsPage />} />
          <Route path="admin/clientes" element={<AdminCustomersPage />} />
          <Route path="admin/assinaturas" element={<AdminAssinaturasPage />} />
          <Route path="admin/categorias" element={<CategoriesPage />} />
          <Route path="admin/categorias/:id/subcategorias" element={<SubcategoriesPage />} />
          <Route path="produtos/novo" element={<NewProductPage />} />
          <Route path="produtos/:id/editar" element={<NewProductPage />} />
          <Route path="chat" element={<ChatPage />} />
          <Route path="segmentacao" element={<SegmentationPage />} />
          <Route path="assinatura" element={<AssinaturaPage />} />
          <Route path="servicos" element={<ServicosPage />} />
          <Route path="faturas" element={<FaturasPage />} />
          <Route path="pagamento/retorno" element={<PagamentoRetornoPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default AppRouter;
